import React, { useEffect, useState, useContext, Fragment } from "react";
import { Link } from "react-router-dom";
import ResultadoDetalleContext from "../../../context/resultadosDetalle/resultadoDetalleContext";
import ResultadoContext from "../../../context/resultados/resultadoContext";
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  PDFViewer,
  Image,
  Font,
} from "@react-pdf/renderer";
import ReactDOM from "react-dom";
import { Line, HorizontalBar } from "react-chartjs-2";
import "chartjs-plugin-annotation";
import Fondo from "../../../marcaagua.jpg";
import Firma from "../../../firma_limed.png";
import ResultadoDetalleState from "../../../context/resultadosDetalle/resultadoDetalleState";
import "../../../stylesResultadoDetalle.css";
import ModalImage from "react-modal-image";
import Html from "react-pdf-html";
import ReactDOMServer from "react-dom/server";
var QRcodeProvider = require("qrcode");
export const Modal = ({ src, alt, caption, onClose }) => {
  console.log(src);
  return (
    <div className="modal-archivo">
      <span className="close" onClick={onClose}>
        &times;
      </span>
      <img className="modal-content-archivo" src={src} alt={alt} />
      {caption.length > 0 && <div className="caption-archivo">{caption}</div>}
    </div>
  );
};
export const ResultadosDetalle = (props) => {
  const resultadoContext = useContext(ResultadoContext);
  const { idSeleccionado } = resultadoContext;

  const resultadoDetalleContext = useContext(ResultadoDetalleContext);
  const {
    paciente,
    medico,
    fecha,
    institucion,
    sucursalNombre,
    sucursalDireccion,
    sexo,
    edad,
    fechaImpresion,
    fechaNacimiento,
    fechaValidacion,
    folio,
    estudios,
    resultadoMedico,
    dataGrafica,
    optionsGrafica,
    qr,
    QRProveedor,
    nombreTipoOrden,
    obtenerDetalleResultados,
    obtenerArchivosDigitales,
    archivosDigitales,
    archivosDigitalesPDF,
    resultadoInterpretacion,
  } = resultadoDetalleContext;

  const [transaccionId, guardarTransaccionId] = useState(0);

  useEffect(() => {
    guardarEstado(idSeleccionado);

    let localId = localStorage.getItem("id");
    if (localId !== 0 && localId !== null) {
      obtenerDetalle(localId);
      obtenerArchivosDigitales(localId);
    } else {
      obtenerDetalle(idSeleccionado);
      obtenerDetalleArchivosDigitales(idSeleccionado);
    }
    //eslint-disable-next-line
  }, []);

  const guardarEstado = (i) => {
    guardarTransaccionId({
      ...transaccionId,
      transaccionId: i,
    });
  };

  const obtenerDetalle = (id) => {
    obtenerDetalleResultados(id);
  };
  const obtenerDetalleArchivosDigitales = (id) => {
    obtenerArchivosDigitales(id);
  };
  let QRProveedorURL;
  if (QRProveedor == null) {
    QRProveedorURL = null;
  } else {
    QRcodeProvider.toDataURL(QRProveedor, function (err, url) {
      QRProveedorURL = url;
    });
  }
  const styles = StyleSheet.create({
    pageBackground: {
      position: "absolute",
      minWidth: "100%",
      minHeight: "100%",
      display: "block",
      height: "100%",
      width: "100%",
    },
    imageFirma: {
      width: "40%",
      height: "20%",
      minWidth: "40%",
      minHeight: "20%",
      alignSelf: "center",
      alignContent: "center",
      alignItems: "center",
    },
    imagenQR: {
      width: "90%",
      height: "98%",
      minWidth: "90%",
      minHeight: "98%",
      alignSelf: "center",
      alignContent: "center",
      alignItems: "center",
      marginTop: "0",
      marginBottom: "0",
    },
    body: {
      padding: 10,
    },
    table: {
      display: "table",
      width: "auto",
      borderRightWidth: 0,
      borderBottomWidth: 0,
    },
    tableFirma: {
      display: "table",
      width: "auto",
      height: "20%",
      minHeight: "20%",
    },
    tableRow: {
      margin: "auto",
      flexDirection: "row",
    },
    tableRowFirma: {
      marginTop: "10",
      flexDirection: "row",
    },
    tableColHeader: {
      width: "25%",
      borderBottomColor: "#000",
      borderLeftWidth: 0,
      borderTopWidth: 0,
    },
    tableCol: {
      width: "25%",
      borderLeftWidth: 0,
      borderTopWidth: 0,
    },
    tableColQR: {
      width: "33%",
      borderLeftWidth: 0,
      borderTopWidth: 0,
      alignSelf: "center",
      alignContent: "center",
      alignItems: "center",
    },
    tableCol2: {
      width: "50%",
      borderLeftWidth: 0,
      borderTopWidth: 0,
      marginLeft: "13px",
    },
    tableCol50Center: {
      width: "50%",
      borderLeftWidth: 0,
      borderTopWidth: 0,
      alignItems: "center",
      alignContent: "center",
      textAlign: "center",
    },
    tableHead: {
      width: "100%",
      borderLeftWidth: 0,
      borderTopWidth: 0,
      textAlign: "center",
    },
    tableCellHeader: {
      margin: 5,
      fontSize: 10,
      fontWeight: "bold",
    },
    tableCellBody: {
      margin: 5,
      fontSize: 8,
      fontWeight: "normal",
    },
    tableCell: {
      margin: 5,
      fontSize: 8,
    },
    textFooter: {
      fontSize: 8,
      alignSelf: "center",
      marginTop: 5,
    },
    tableCellCenter: {
      margin: 5,
      fontSize: 8,
    },
    tableCellTab: {
      margin: 5,
      marginLeft: "20px",
      fontSize: 8,
    },
    footerText: {
      //margin: 5,
      fontSize: 8,
      marginLeft: "20px",
      marginTop: "15px",
    },
    footerTextMetodo: {
      //margin: 5,
      fontSize: 8,
      marginLeft: "20px",
      marginTop: "0px",
    },
    divHeader: {
      marginLeft: "15px",
    },
  });

  const Documento = () => (
    <PDFViewer width="100%" height="100%">
      <Document title="resultado">
        <Page style={styles.body} size="A4" wrap>
          <Image src={Fondo} style={styles.pageBackground} />
          <View style={styles.table}>
            <View style={styles.tableRow}>
              <View style={styles.tableCol2}>
                <Text style={styles.tableCell}></Text>
              </View>
              <View style={styles.tableCol2}>
                <Text style={styles.tableCell}></Text>
              </View>
            </View>
            <View style={styles.tableRow}>
              <View style={styles.tableCol2}>
                <Text style={styles.tableCell}></Text>
              </View>
              <View style={styles.tableCol2}>
                <Text style={styles.tableCell}></Text>
              </View>
            </View>
            <View style={styles.tableRow}>
              <View style={styles.tableCol2}>
                <Text style={styles.tableCell}></Text>
              </View>
              <View style={styles.tableCol2}>
                <Text style={styles.tableCell}></Text>
              </View>
            </View>
            <View style={styles.tableRow}>
              <View style={styles.tableCol2}>
                <Text style={styles.tableCell}></Text>
              </View>
              <View style={styles.tableCol2}>
                <Text style={styles.tableCell}></Text>
              </View>
            </View>
            <View style={styles.tableRow}>
              <View style={styles.tableCol2}>
                <Text style={styles.tableCell}></Text>
              </View>
              <View style={styles.tableCol2}>
                <Text style={styles.tableCell}></Text>
              </View>
            </View>
            <View style={styles.tableRow}>
              <View style={styles.tableCol2}>
                <Text style={styles.tableCell}></Text>
              </View>
              <View style={styles.tableCol2}>
                <Text style={styles.tableCell}></Text>
              </View>
            </View>
            <View style={styles.tableRow}>
              <View style={styles.tableCol2}>
                <Text style={styles.tableCell}></Text>
              </View>
              <View style={styles.tableCol2}>
                <Text style={styles.tableCell}></Text>
              </View>
            </View>
            <View style={styles.tableRow}>
              <View style={styles.tableCol2}>
                <Text style={styles.tableCell}></Text>
              </View>
              <View style={styles.tableCol2}>
                <Text style={styles.tableCell}></Text>
              </View>
            </View>
            <View style={styles.tableRow}>
              <View style={styles.tableCol2}>
                <Text style={styles.tableCell}></Text>
              </View>
              <View style={styles.tableCol2}>
                <Text style={styles.tableCell}></Text>
              </View>
            </View>
          </View>
          <View style={styles.table}>
            <View style={styles.tableRow}>
              <View style={styles.tableCol2}>
                <Text style={styles.tableCell}>PACIENTE: {paciente}</Text>
              </View>
              <View style={styles.tableCol2}>
                <Text
                  style={styles.tableCell}
                >{`SEXO: ${sexo}  EDAD: ${edad}`}</Text>
              </View>
            </View>
            <View style={styles.tableRow}>
              <View style={styles.tableCol2}>
                <Text style={styles.tableCell}>MEDICO: {medico}</Text>
              </View>
              <View style={styles.tableCol2}>
                <Text style={styles.tableCell}>
                  FECHA NACIMIENTO: {fechaNacimiento}
                </Text>
              </View>
            </View>
            <View style={styles.tableRow}>
              <View style={styles.tableCol2}>
                <Text style={styles.tableCell}>FECHA REGISTRO: {fecha}</Text>
              </View>
              <View style={styles.tableCol2}>
                <Text style={styles.tableCell}>FOLIO: {folio}</Text>
              </View>
            </View>
            <View style={styles.tableRow}>
              <View style={styles.tableCol2}>
                <Text style={styles.tableCell}>
                  FECHA VALIDACIÓN: {fechaValidacion}
                </Text>
              </View>
              <View style={styles.tableCol2}>
                <Text style={styles.tableCell}></Text>
              </View>
            </View>
            <View style={styles.tableRow}>
              <View style={styles.tableCol2}>
                <Text style={styles.tableCell}>
                  SUCURSAL: {sucursalNombre + ", " + sucursalDireccion}
                </Text>
              </View>
              <View style={styles.tableCol2}>
                <Text style={styles.tableCell}></Text>
              </View>
            </View>
            <View style={styles.tableRow}>
              <View style={styles.tableCol2}>
                <Text style={styles.tableCell}>
                  {institucion.length > 0 ? `INSTITUCIÓN: ${institucion}` : ""}
                </Text>
              </View>
              <View style={styles.tableCol2}>
                <Text style={styles.tableCell}></Text>
              </View>
            </View>
          </View>
          {resultadoInterpretacion != ""
            ? estudios.map((estudio) => {
                return (
                  <View key={estudio.row} style={styles.table}>
                    <View style={styles.tableRow}>
                      <View style={styles.tableHead}>
                        <Text style={styles.tableCellHeader}>
                          {estudio.estudio}
                        </Text>
                        <Html style={styles.tableCellBody}>
                          {estudio.resultadoInterpretacion}
                        </Html>
                      </View>
                    </View>
                  </View>
                );
              })
            : estudios.map((estudio) => {
                return (
                  <View key={estudio.row} style={styles.table}>
                    <View style={styles.tableRow}>
                      <View style={styles.tableHead}>
                        <Text style={styles.tableCellHeader}>
                          {estudio.estudio}
                        </Text>
                      </View>
                    </View>
                    {resultadoMedico.map((res) => {
                      return (
                        <Fragment key={res.row}>
                          {res.agrupador !== "" &&
                          estudio.estudio === res.estudio ? (
                            <View key={res.row} style={styles.tableRow}>
                              <View style={styles.tableColHeader}>
                                <Text style={styles.tableCellHeader}>
                                  {res.agrupador}
                                </Text>
                              </View>
                              <View style={styles.tableColHeader}>
                                <Text style={styles.tableCellHeader}>
                                  Valor
                                </Text>
                              </View>
                              <View style={styles.tableColHeader}>
                                <Text style={styles.tableCellHeader}>
                                  Rango normal
                                </Text>
                              </View>
                              <View style={styles.tableColHeader}>
                                <Text style={styles.tableCellHeader}>
                                  Unidad
                                </Text>
                              </View>
                            </View>
                          ) : res.row === "1" ? (
                            <View key={res.row} style={styles.tableRow}>
                              <View style={styles.tableColHeader}>
                                <Text style={styles.tableCellHeader}>
                                  {res.agrupador}
                                </Text>
                              </View>
                              <View style={styles.tableColHeader}>
                                <Text style={styles.tableCellHeader}>
                                  Valor
                                </Text>
                              </View>
                              <View style={styles.tableColHeader}>
                                <Text style={styles.tableCellHeader}>
                                  Rango normal
                                </Text>
                              </View>
                              <View style={styles.tableColHeader}>
                                <Text style={styles.tableCellHeader}>
                                  Unidad
                                </Text>
                              </View>
                            </View>
                          ) : null}
                          {res.medicion !== "" &&
                          estudio.estudio === res.estudio ? (
                            <View style={styles.tableRow}>
                              <View style={styles.tableCol}>
                                <Text style={styles.tableCellTab}>
                                  {res.medicion}
                                </Text>
                              </View>
                              <View style={styles.tableCol}>
                                <Text style={styles.tableCell}>
                                  {res.valorReal}
                                </Text>
                              </View>
                              <View style={styles.tableCol}>
                                <Text style={styles.tableCell}>
                                  {res.valorNormal}
                                </Text>
                              </View>
                              <View style={styles.tableCol}>
                                <Text style={styles.tableCell}>
                                  {res.unidadMedida}
                                </Text>
                              </View>
                            </View>
                          ) : null}
                        </Fragment>
                      );
                    })}
                    <View>
                      <Text
                        style={styles.footerText}
                      >{`Muestra: ${estudio.muestra}`}</Text>
                      <Text
                        style={styles.footerTextMetodo}
                      >{`Método: ${estudio.metodo}`}</Text>
                    </View>
                  </View>
                );
              })}
          {resultadoInterpretacion != "" ? (
            <View style={styles.tableFirma} fixed></View>
          ) : (
            <View style={styles.tableFirma} fixed>
              <View style={styles.tableRowFirma}>
                <View style={styles.tableColQR}></View>
                <View style={styles.tableColQR}>
                  <View>
                    <Image src={Firma} style={styles.imageFirma} />
                    <Text style={styles.textFooter}>ATENTAMENTE</Text>
                    <Text style={styles.textFooter}>
                      Q.B.P. NORMA ZENIL HIDALGO
                    </Text>
                    <Text style={styles.textFooter}>Cedula Prof. :488950</Text>
                  </View>
                </View>
                <View style={styles.tableColQR}></View>
              </View>
              {QRProveedorURL !== null && QRProveedorURL !== "" ? (
                <View style={styles.tableRowFirma}>
                  <View style={styles.tableColQR}>
                    <View>
                      <Image src={qr} style={styles.imagenQR} />
                    </View>
                  </View>
                  <View style={styles.tableColQR}></View>
                  <View style={styles.tableColQR}>
                    <View>
                      <Image src={QRProveedorURL} style={styles.imagenQR} />
                      <Text style={styles.textFooter}>{nombreTipoOrden}</Text>
                    </View>
                  </View>
                </View>
              ) : (
                <View style={styles.tableRowFirma}>
                  <View style={styles.tableColQR}></View>
                  <View style={styles.tableColQR}>
                    <View>
                      <Image src={qr} style={styles.imagenQR} />
                    </View>
                  </View>
                  <View style={styles.tableColQR}></View>
                </View>
              )}
            </View>
          )}
        </Page>
      </Document>
    </PDFViewer>
  );

  const exportarPDF = () => {
    ReactDOM.render(
      <div className="card h100 p20 mt20">
        <div id="pfDoc" style={{ height: "100vh" }}>
          <Documento />
        </div>
      </div>,
      document.getElementById("pdf")
    );
  };
  const [isOpen, setIsOpen] = useState(false);
  const showModal = () => setIsOpen(true);
  let htmlPart = resultadoInterpretacion;
  return (
    <div className="container">
      <section>
        <div className="my30 card p10">
          <div className="row">
            <div className="col-xs-10">
              <Link
                className="btn btn-primary"
                to={{
                  pathname: "/resultados",
                  state: {
                    pacienteId: props.location.state
                      ? props.location.state.pacienteId
                      : null,
                  },
                }}
              >
                <i className="bi bi-arrow-left"></i>
              </Link>
            </div>
            <div className="col-xs-2">
              <button
                type="button"
                className="btn btn-primary"
                data-toggle="modal"
                data-target=".bd-example-modal-lg"
                onClick={exportarPDF}
              >
                Generar PDF
              </button>
            </div>
          </div>
          <div className="row">
            <div className="col-xs-6">PACIENTE: {paciente}</div>
            <div className="col-xs-6">{`SEXO: ${sexo}  EDAD: ${edad}`}</div>
          </div>
          <div className="row">
            <div className="col-xs-6">MEDICO: {medico}</div>
            <div className="col-xs-6">FECHA IMPRESIÓN: {fechaImpresion}</div>
          </div>
          <div className="row">
            <div className="col-xs-6">FECHA: {fecha}</div>
            <div className="col-xs-6">FOLIO: {folio}</div>
          </div>
          <div className="row">
            <div className="col-xs-6">INSTITUCIÓN: {institucion}</div>
            <div className="col-xs-6"></div>
          </div>
          {resultadoInterpretacion != ""
            ? estudios.map((estudio) => {
                return (
                  <div key={estudio.row} className="p15">
                    <div>
                      <div className="table-container">
                        <table className="table table-borderless">
                          <thead>
                            <tr>
                              <th colSpan="5" className="text-center">
                                <strong>{estudio.estudio}</strong>
                              </th>
                            </tr>
                          </thead>

                          <tbody>
                            <div
                              dangerouslySetInnerHTML={{ __html: htmlPart }}
                            />
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                );
              })
            : estudios.map((estudio) => {
                return (
                  <div key={estudio.row} className="p15">
                    <div>
                      <div className="table-container">
                        <table className="table table-borderless">
                          <thead>
                            <tr>
                              <th colSpan="5" className="text-center">
                                <strong>{estudio.estudio}</strong>
                              </th>
                            </tr>
                          </thead>

                          <tbody>
                            {resultadoMedico.map((res) => {
                              return (
                                <Fragment key={res.row}>
                                  {res.agrupador !== "" &&
                                  estudio.estudio === res.estudio ? (
                                    <tr>
                                      <th>{res.agrupador}</th>
                                      <th>Valor</th>
                                      <th>Rango normal</th>
                                      <th>Unidad</th>
                                      <th></th>
                                    </tr>
                                  ) : res.row === "1" ? (
                                    <tr>
                                      <th></th>
                                      <th>Valor</th>
                                      <th>Rango normal</th>
                                      <th>Unidad</th>
                                      <th></th>
                                    </tr>
                                  ) : null}
                                  {res.medicion !== "" &&
                                  estudio.estudio === res.estudio ? (
                                    <tr>
                                      <td>&ensp;&ensp;{res.medicion}</td>
                                      <td>
                                        {res.valorReal < res.parametro_min ||
                                        res.valorReal > res.parametro_max ? (
                                          res.valor !== 0 &&
                                          res.parametro_max !== 0 ? (
                                            <strong>{res.valorReal}</strong>
                                          ) : (
                                            res.valorReal
                                          )
                                        ) : (
                                          res.valorReal
                                        )}
                                      </td>
                                      <td>{res.valorNormal}</td>
                                      <td>{res.unidadMedida}</td>
                                      <td>
                                        {res.valor !== 0 &&
                                        res.parametro_max !== 0 ? (
                                          <HorizontalBar
                                            data={JSON.parse(res.grafica)}
                                            width={100}
                                            height={45}
                                            options={JSON.parse(
                                              res.opcionesGrafica
                                            )}
                                          />
                                        ) : null}
                                      </td>
                                    </tr>
                                  ) : null}
                                </Fragment>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <div className="row">
                      &ensp;{`Muestra: ${estudio.muestra}`}
                    </div>
                    <div className="row">
                      &ensp;{`Método: ${estudio.metodo}`}
                    </div>
                    <div className="row mt10 pr10">
                      <Line data={dataGrafica} options={optionsGrafica} />
                    </div>
                  </div>
                );
              })}
          <div className="p15">
            <div>
              <div className="table-container">
                <table className="table table-borderless">
                  <thead>
                    <tr>
                      <th colSpan="5" className="text-center">
                        <strong>{"Archivos Digitales"}</strong>
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr>
                      <th>Archivos</th>
                      <th>Nombre</th>
                      <th></th>
                    </tr>
                    {[...archivosDigitalesPDF, ...archivosDigitales].map(
                      (archivos, index) => {
                        return (
                          <tr key={index}>
                            <td>
                              <div className="App">
                                <div className="AppImage">
                                  {archivos.contentType ===
                                    "application/octet-stream" ||
                                  archivos.contentType === "application/pdf" ? (
                                    <a
                                      href={archivos.uri}
                                      download={archivos.filename}
                                      target="_blank"
                                    >
                                      <i className="bi bi-file-earmark"></i>
                                    </a>
                                  ) : (
                                    <ModalImage
                                      small={archivos.uri}
                                      large={archivos.uri}
                                    />
                                  )}
                                </div>
                              </div>
                            </td>
                            <td>{archivos.filename}</td>
                          </tr>
                        );
                      }
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div
        className="modal fade bd-example-modal-lg"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="myLargeModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg">
          <div id="pdf" className="modal-content"></div>
        </div>
      </div>
    </div>
  );
};
// const rootElement = document.getElementById("root");
// ReactDOM.render(<ResultadosDetalle />, rootElement);
// {resultadoInterpretacion != "" ? (
//   <div className="p15">
//     <div>
//       <div className="table-container">
//         <table className="table table-borderless">
//           <thead>
//             <tr>
//               <th colSpan="5" className="text-center">
//                 <strong>{"Archivos Digitales"}</strong>
//               </th>
//             </tr>
//           </thead>

//           <tbody>
//             <tr>
//               <th>Archivos</th>
//               <th>Nombre</th>
//               <th></th>
//             </tr>
//             {archivosDigitales.map((archivos) => {
//               return (
//                 <tr>
//                   <td>
//                     <div className="App">
//                       <div className="AppImage">
//                         <ModalImage
//                           small={archivos.uri}
//                           large={archivos.uri}
//                         />
//                       </div>
//                     </div>
//                     {/*<img
//                   className="image-archivo"
//                   onClick={showModal}
//                   src={archivos.uri}e ayu
//                   alt={archivos.filename}
//                   />
//                   {isOpen && (
//                   <Modal
//                       src={archivos.uri}
//                       alt={archivos.filename}                            caption="caption"
//                       onClose={() => setIsOpen(false)}
//                   />
//                   )}*/}
//                   </td>
//                   <td>{archivos.filename}</td>
//                 </tr>
//               );
//             })}
//             {/* </Fragment> */}
//           </tbody>
//         </table>
//       </div>
//     </div>
//   </div>
// ) : (
//   ""
// )}
